import React, { ReactNode } from 'react'
import { format } from 'date-fns'
import './ConfirmationScreen.scss'
import { useUserTimezone } from '../../hooks/useUserTimezone'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { MODULE_KEYS, SELF_SCHEDULING_DEFAULTS } from '../../moduleRegistry'
import { PaperPlaneIcon, CalendarIcon, ClockIcon } from './icons'

interface DetailCardProps {
  icon: ReactNode
  label: string
  value: ReactNode
}

const DetailCard = ({ icon, label, value }: DetailCardProps) => (
  <div className="confirmation_screen_detail_card">
    <div className="confirmation_screen_detail_icon">{icon}</div>
    <div className="confirmation_screen_detail_content">
      <div className="confirmation_screen_detail_label">{label}</div>
      <div className="confirmation_screen_detail_value">{value}</div>
    </div>
  </div>
)

interface ConfirmationScreenProps {
  date: Date
  time: string
}

function ConfirmationScreen ({ date, time }: ConfirmationScreenProps) {
  const formattedDate = format(date, 'EEEE, MMMM do, yyyy')
  const { abbreviation: userTimezone } = useUserTimezone()
  const { confirmationText } = useModuleConfig(MODULE_KEYS.selfScheduling, SELF_SCHEDULING_DEFAULTS)

  return (
    <div className="confirmation_screen">
      <div className="confirmation_screen_info">
        <div className="confirmation_screen_info_icon">
          <PaperPlaneIcon />
        </div>
        <p className="confirmation_screen_info_text">
          {confirmationText}
        </p>
      </div>

      <div className="confirmation_screen_details">
        <h3 className="confirmation_screen_details_title">Appointment Details:</h3>

        <div className="confirmation_screen_detail_cards">
          <DetailCard icon={<CalendarIcon />} label="Date:" value={formattedDate} />
          <DetailCard icon={<ClockIcon />} label="Time:" value={`${time} ${userTimezone} (30 Minutes)`} />
        </div>
      </div>
    </div>
  )
}

export default ConfirmationScreen
